<app-dashboard>
    <p>encryption works!</p>
</app-dashboard>
